import { defineRequest } from "../axios"
import type { CampaignThresholdConfigurationResponse, UpdateCampaignThresholdConfigurationPayload } from "./types"

// 取得系統閾值設定
export const getCampaignThresholdConfiguration = defineRequest<CampaignThresholdConfigurationResponse>({
    url: "/systems/campaign-threshold-configuration/",
    method: "get",
})

// 更新系統閾值設定
export const updateCampaignThresholdConfiguration = defineRequest<
    CampaignThresholdConfigurationResponse,
    UpdateCampaignThresholdConfigurationPayload
>({
    url: "/systems/campaign-threshold-configuration/",
    method: "put",
})
